import { useState } from "react";

const predefinedResponses = {
  // 🇮🇹 — Trasporto specifico (da Sanur, Padang Bai, Lombok)
  "come arrivo da sanur a gili air": "Da Sanur parte un traghetto/speed boat tra le 08:00 e le 12:00, impiega circa 3h15–4h e costa tra $60 e $121 (€55–110) :contentReference[oaicite:1]{index=1}.",
  "quante partenze ci sono da sanur": "Circa 27 corse al giorno da Sanur, la prima intorno alle 06:00 e l'ultima verso mezzogiorno :contentReference[oaicite:2]{index=2}.",
  "quanto dura il traghetto da sanur": "Di solito tra 3h15 e 5h, la media è 4h10 :contentReference[oaicite:3]{index=3}.",
  "quanto costa da sanur": "I prezzi vanno da $21 a $63 (€20–60), mediamente circa €36 a tratta :contentReference[oaicite:4]{index=4}.",
  "esistono combinati taxi+traghetto": "Sì, taxi+traghetto costano tra $22 e $51 (€21–50), e durano 3–7 ore :contentReference[oaicite:5]{index=5}.",
  "come arrivo da padang bai": "Ci sono ferry e van+ferry da Sanur; con taxi+traghetto via Padang Bai impiega ~4h8m :contentReference[oaicite:6]{index=6}.",
  "fast boat bali gili air cost": "Una fast boat da Bali a Gili Air costa in media $31 (da $25 a $46) e impiega circa 2h23m :contentReference[oaicite:7]{index=7}.",
  "immagini traghetto lento sanur bangsal": "Non esiste un traghetto diretto lento per Gili Air; di solito si usa la speed boat veloce :contentReference[oaicite:8]{index=8}.",

  // 🇮🇹 — Trasporto da Bangsal (Lombok)
  "come arrivo da bangsal a gili air": "Da Bangsal parte un’imbarcazione pubblica senza orario fisso tra le 08:00 e le 17:00, quando è piena (min 40 persone) :contentReference[oaicite:9]{index=9}.",
  "quanto costa da bangsal gili air": "Il prezzo è ~19.500 IDR (circa €1,10) :contentReference[oaicite:10]{index=10}.",
  "quanto dura il viaggio da bangsal": "Circa 15 minuti © :contentReference[oaicite:11]{index=11}.",
  "quante corse da gili air a bangsal": "Ci sono 8 partenze giornaliere da Gili Air verso Bangsal, la prima verso le 10:10 e l’ultima intorno alle 17:20 :contentReference[oaicite:12]{index=12}.",
  "ci sono speed boat da bangsal": "Sì, operano operatori privati e charter con barri da US$12‑15 :contentReference[oaicite:13]{index=13}.",
  "posso prendere charter privato": "Certamente, operatori privati offrono transfer personalizzati 24/7 :contentReference[oaicite:14]{index=14}.",
  "bangsal orari ufficio": "L’ufficio barche pubbliche chiude alle 16:30 (ultima partenza alle 17:00) :contentReference[oaicite:15]{index=15}.",

  // 🇮🇹 — Info utili generale
  "posso portare la bici": "Sì, ma sulle barche piccole lo scarico è limitato: meglio chiedere all’operatore.",
  "ci sono bagni sulla barca": "Sui ferry da Sanur sì; sulle speed boat e barche locali no.",
  "fa male il mare": "Molti soffrono di mal di mare, opta per barche più grandi se sensibile :contentReference[oaicite:16]{index=16}.",
  "c'è assistenza medica a gili air": "Sì, c'è una piccola clinica d’emergenza vicino al porto.",
  "ci sono veicoli a motore": "No, solo bici, passeggini e cidomo (calessi tradizionali) :contentReference[oaicite:17]{index=17}.",
  "serve passaporto": "Portalo sempre, è utile nel caso di controlli navali o corse combinate internazionali.",

  // 🇺🇸 — Transport from Sanur
  "how to get from sanur to gili air": "Take a ferry or fast boat from 08:00 to 12:00, duration 3h15–4h, costs $60–121 €60–110 :contentReference[oaicite:18]{index=18}.",
  "how many departures from sanur": "About 27 daily, first around 06:00, last at noon :contentReference[oaicite:19]{index=19}.",
  "how long is the trip sanur to gili air": "Usually 3h15–5h, avg 4h10 :contentReference[oaicite:20]{index=20}.",
  "how much is the fare sanur": "Between $21–63 (€20–60), avg €36 :contentReference[oaicite:21]{index=21}.",
  "is taxi+ferry available": "Yes, taxi+ferry costs $22–51, takes 3–7 h :contentReference[oaicite:22]{index=22}.",
  "fast boat cost bali to gili air": "Island fast boats cost avg $31 (range $25–46), time ~2h23m :contentReference[oaicite:23]{index=23}.",

  // 🇺🇸 — Transport from Bangsal
  "how to get from bangsal to gili air": "Public boats run from 08:00 to 17:00, leave when full (min 40 pax) :contentReference[oaicite:24]{index=24}.",
  "how much is bangsal to gili air": "~19,500 IDR (~€1.10) :contentReference[oaicite:25]{index=25}.",
  "how long is bangsal to gili air": "About 15 minutes :contentReference[oaicite:26]{index=26}.",

  // ... Continua fino a totalizzare 300 voci ...

  "default": "Mi dispiace, non ho capito. Vuoi che ti connetta via WhatsApp?"
};

export default function ChatWindow({ onClose }) {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");

  const handleSend = () => {
    if (!input.trim()) return;

    const replyKey = Object.keys(predefinedResponses).find(key =>
      input.toLowerCase().includes(key)
    );

    const response = replyKey
      ? predefinedResponses[replyKey]
      : "Non sono sicuro di come rispondere. Ti reindirizzo su WhatsApp...";

    setMessages(prev => [...prev, { text: input, sender: "user" }]);

    setTimeout(() => {
      setMessages(prev => [...prev, { text: response, sender: "bot" }]);

      if (!replyKey) {
        setTimeout(() => {
          window.open(
            "https://wa.me/628533647758?text=Ciao,+ho+una+domanda:+"
            + encodeURIComponent(input),
            "_blank"
          );
        }, 1000);
      }

      saveConversation(input, response); // puoi definire questa funzione in futuro
    }, 600);

    setInput(""); // svuota il campo
  };
  function saveConversation(question, answer) {
  // Per ora la salviamo solo in console (puoi poi mandarla a un server, salvarla in localStorage, ecc.)
  console.log("Salvata conversazione:", { question, answer });
}

  return (
    <div className="fixed bottom-20 right-5 w-80 bg-white border rounded shadow-lg z-50">ss
      <div className="bg-green-500 text-white p-2 font-bold flex justify-between">
        Chat WhatsApp
        <button onClick={onClose}>✖️</button>
      </div>
      <div className="p-2 h-64 overflow-y-auto text-sm">
        {messages.map((msg, index) => (
          <div key={index} className={`my-1 ${msg.sender === "user" ? "text-right" : "text-left"}`}>
            <div className={`inline-block px-3 py-1 rounded ${msg.sender === "user" ? "bg-green-100" : "bg-gray-200"}`}>
              {msg.text}
            </div>
          </div>
        ))}
      </div>
      <div className="flex p-2 border-t">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          className="flex-grow px-2 py-1 border rounded-l text-sm"
          placeholder="Scrivi un messaggio..."
        />
        <button onClick={handleSend} className="bg-green-500 text-white px-3 rounded-r text-sm">
          ➤
        </button>
      </div>
      <div className="text-center p-2">
        <a
          href="https://wa.me/628533867758?text=Ciao%20vorrei%20parlare%20con%20un%20operatore"
          target="_blank"
          rel="noopener noreferrer"
          className="text-green-600 underline text-sm"
        >
          Parla con un operatore su WhatsApp
        </a>
      </div>
    </div>
  );
}
